import React from "react";
import { useRoutes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Home } from "../../pages/Home";
import { FindProduct } from "../../pages/FindProduct";
import { Selling } from "../../pages/Selling";
import ProductPage from "../../routes/ProductPage";
import { easeInOut } from "framer-motion";
import About from "../../pages/About us";

const pageTransition = {
  duration: 0.2,
  ease: easeInOut,
};

const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};


export const MyRouter = React.memo(() => {
  const location = useLocation();

  const routes = useRoutes(
    [
      { path: "/", element: <HomeWrapper /> },
      { path: "/FindProduct", element: <FindProductWrapper /> },
      { path: "/selling", element: <SellingWrapper /> },
      { path: "/selling/:id", element: <ProductPageWrapper /> },
      { path: "/about", element: <About /> },
    ],
    location
  );

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={pageTransition}
        style={{ position: "absolute", width: "100%" }}
      >
        {routes}
      </motion.div>
    </AnimatePresence>
  );
});

const HomeWrapper = () => <Home />;
const FindProductWrapper = () => <FindProduct />;
const SellingWrapper = () => <Selling />;
const ProductPageWrapper = () => <ProductPage />;
